import { apiClientV2 } from '@/services/rest-api/apiClient';
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL;


const get = async (queryParam) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/fleet-task-timeline',
    params: queryParam,
  });

  return response?.data;
};

export default { get };